import OrderProductGridContainer from '../../../../../../orders/products/product/grid/components/orderProductGrid/components/grid/components/OrderProductGridContainer';
import { CombinationLineProps } from '../../types/combinationLine.types';
import CombinationPackChip from '../CombinationPackChip/CombinationPackChip';
import CombinationPasteStateButton from '../CombinationPasteStateButton/CombinationPasteStateButton';
import CombinationLineUnavailableGrid from './CombinationLineUnavailableGrid';

type CombinationLineDesktopGridProps = Pick<
  CombinationLineProps,
  'gridLength' | 'orderProductGridContainerProps' | 'pasteStateButtonProps'
>;

const CombinationLineDesktopGrid = ({
  gridLength,
  orderProductGridContainerProps,
  pasteStateButtonProps,
}: CombinationLineDesktopGridProps) => {
  const hasPasteStateButton = !!pasteStateButtonProps;
  const hasPackChip =
    !hasPasteStateButton && orderProductGridContainerProps.selectedPacks.length > 0;

  const getExtraButton = () => {
    if (pasteStateButtonProps) {
      return <CombinationPasteStateButton {...pasteStateButtonProps} />;
    }

    if (hasPackChip) {
      return <CombinationPackChip />;
    }

    return null;
  };

  return (
    <>
      <CombinationLineUnavailableGrid gridLength={gridLength} />
      <OrderProductGridContainer
        {...orderProductGridContainerProps}
        hideButtons={
          orderProductGridContainerProps.hideButtons || hasPasteStateButton || hasPackChip
        }
        ExtraButton={getExtraButton()}
      />
    </>
  );
};

export default CombinationLineDesktopGrid;
